import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class UserContacts {
  constructor($scope, $rootScope, UserContactService, UserService) {
    $scope.manage_tabs = ['All', 'Pending Invitations', 'Pending Accounts', 'Accounts', 'Without Accounts'];

    $scope.edit_tabs = [
      'Contact General',
      'Account General',
      'Preferences',
      'Newsletter Settings',
      'Campaign Settings',
      'ePrivacy',
      'GDPR',
      'Matching Options',
      'Page Style',
      'Welcome Notification'
    ];
    
    $scope.$watch('dialog_contact.epr_marketing_permission', function() {
      if ($scope.dialog_contact.epr_marketing_permission.length > 0) {
        $scope.dialog_contact.epr_marketing_permission_title = $scope.dialog_contact.epr_marketing_permission + ' (admin)';
      }
    });
    
    $scope.$watch('dialog_contact.epr_based_to', function() {
      if ($scope.dialog_contact.epr_based_to.length > 0) {
        $scope.dialog_contact.epr_based_to_title = $scope.dialog_contact.epr_based_to + ' (admin)';
      }
    });

    $scope.set_selected_manage_tab = function(index) {
      $scope.selected_manage_tab = index;
    };

    $scope.set_selected_edit_tab = function(index) {
      $scope.selected_edit_tab = index;
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.get_new_account = function() {
      return {
        id: null,
        username: null,
        password: null,
        retype_password: null,
        status: 'activated'
      };
    };

    $scope.get_new_newsletter_settings = function() {
      return {
        categories: [],
        frequency: 0,
        filter: 0,
        greeting_line: window.user_country_id == 83 || window.user_country_id == 56 ? 'Αξιότιμοι Κύριοι και Κυρίες' : 'Dear Ladies and Gentlemen',
        message_type: 0
      };
    };

    $scope.get_new_matching_settings = function() {
      return {
        option: 0,
        percentage: 25,
        minimum_quantity: 0
      };
    };

    $scope.get_new_frontend_settings = function() {
      return {
        view_type: 0,
        welcome_notification: 0,
        welcome_notification_frequency: 0
      };
    };

    $scope.add_contact = function() {
      $scope.dialog_contact = angular.copy(window.contact);
      $scope.dialog_old_email = null;
      $scope.selected_edit_tab = 0;
      $scope.dialog_contact.account = $scope.get_new_account();
      $scope.dialog_contact.newsletter_settings = $scope.get_new_newsletter_settings();
      $scope.dialog_contact.matching_settings = $scope.get_new_matching_settings();
      $scope.dialog_contact.frontend_settings = $scope.get_new_frontend_settings();
      if (!$scope.dialog_contact.campaign_status_details)
        $scope.dialog_contact.campaign_status_details = {};
      $scope.open_dialog('user_contact_dialog');
    };

    $scope.edit_contact = function(contact) {
      $scope.dialog_contact = contact;
      $scope.dialog_old_email = contact.email;
      $scope.selected_edit_tab = 0;
      if (!contact.account)
        contact.account = $scope.get_new_account();
      $scope.dialog_old_username = contact.account.username;
      $scope.dialog_contact.account.password = '';
      $scope.dialog_contact.account.retype_password = '';
      if (!contact.newsletter_settings)
        contact.newsletter_settings = $scope.get_new_newsletter_settings();
      if (!contact.newsletter_settings.message_type)
        contact.newsletter_settings.message_type = 0;
      if (!contact.matching_settings)
        contact.matching_settings = $scope.get_new_matching_settings();
      if (!contact.frontend_settings)
        contact.frontend_settings = $scope.get_new_frontend_settings();
      $scope.set_contact_data();
      if (!$scope.dialog_contact.campaign_status_details)
        $scope.dialog_contact.campaign_status_details = {};
      $scope.open_dialog('user_contact_dialog');
    };

    $scope.delete_contact = function(index) {
      if (confirm('Are you sure you want to delete this contact?')) {
        UserContactService.delete($scope.user_contacts[index].id).then(function(data) {
          if (data.success) {
            $scope.user_contacts.splice(index, 1);
            $rootScope.$broadcast('set_sidebar_data', [0, 0, [{
              type: 'counter',
              value: $scope.user_contacts.length
            }, {
              type: 'counter',
              value: _.filter($scope.user_contacts, function(c) {
                return c.account && c.account.id;
              }).length
            }]]);
          }
        });
      }
    };

    $scope.save_contact = function() {
      $scope.updating_contact = true;
      if ($scope.dialog_contact.email === null || $scope.dialog_contact.email == $scope.dialog_old_email) {
        $scope.validate_account();
      } else {
        UserService.contact_email_exists($scope.dialog_contact.email, $scope.dialog_contact.user_id).then(function(data) {
          if (data.exists) {
            $scope.contact_error = 'Contact email already exists!';
            $scope.updating_contact = false;
          } else {
            $scope.contact_error = '';
            $scope.validate_account();
          }
        });
      }
    };

    $scope.validate_password = function(account) {
      var password = account.password;
      var password2 = account.retype_password;
      if (!(password || password2) || password.length === 0 || (password != password2)) {
        $scope.account_error = 'Account password empty or password mismatch!';
        $scope.updating_contact = false;
        return false;
      }
      $scope.account_error = '';
      return true;
    };

    $scope.validate_account = function() {
      var account = $scope.dialog_contact.account;
      if (!account.id) {
        var username = account.username;
        if (username && username.length > 0) {
          if ($scope.validate_password(account)) {
            UserService.account_email_exists(username).then(function(data) {
              if (data.exists) {
                $scope.account_error = 'Account email already exists!';
                $scope.updating_contact = false;
              } else {
                $scope.account_error = '';
                $scope.update_contact();
              }
            });
          }
        } else {
          $scope.update_contact();
        }
      } else {
        account.new_username = null;
        account.new_password = null;
        if (account.username && account.username.length > 0 && $scope.dialog_old_username != account.username)
          account.new_username = account.username;
        if (account.password && account.retype_password && $scope.validate_password(account))
          account.new_password = account.password;
        if (account.new_username) {
          UserService.account_email_exists(account.new_username).then(function(data) {
            if (data.exists) {
              $scope.account_error = 'Account email already exists!';
              $scope.updating_contact = false;
            } else {
              $scope.account_error = '';
              $scope.update_contact();
            }
          });
        } else {
          $scope.update_contact();
        }
      }
    };

    $scope.set_contact_data = function() {
      angular.forEach($scope.newsletter_categories, function(category) {
        if ($scope.dialog_contact.newsletter_settings.categories)
          category.checked = $scope.dialog_contact.newsletter_settings.categories.indexOf(category.id) > -1;
      });
      angular.forEach($scope.product_categories, function(category) {
        if ($scope.dialog_contact.product_categories)
          category.checked = $scope.dialog_contact.product_categories.indexOf(category.id) > -1;
      });
    };

    $scope.get_contact_data = function() {
      var categories = [];
      angular.forEach($scope.newsletter_categories, function(category) {
        if (category.checked)
          categories.push(category.id);
      });
      $scope.dialog_contact.newsletter_settings.categories = categories;

      var product_categories = [];
      angular.forEach($scope.product_categories, function(category) {
        if (category.checked)
          product_categories.push(category.id);
      });
      $scope.dialog_contact.product_categories = product_categories;

      if ($scope.dialog_contact.campaign_status === 1) {
        $scope.dialog_contact.campaign_status_details = null;
      }

      if ($scope.dialog_contact.campaign_status !== 4) {
        $scope.dialog_contact.campaign_probation_start = null;
        $scope.dialog_contact.campaign_probation_end = null;
      } else {
        $scope.dialog_contact.campaign_probation_end = $scope.dialog_contact.campaign_probation_end + ' 23:59:59';
      }
    };

    $scope.update_contact = function() {
      $scope.get_contact_data();
      UserContactService.save($scope.dialog_contact).then(function(data) {
        if (data.success) {
          $scope.updating_contact = false;
          $.fancybox.close();
          $scope.user_contacts = data.user_contacts;
          $rootScope.$broadcast('set_sidebar_data', [0, 0, [{
            type: 'counter',
            value: $scope.user_contacts.length
          }, {
            type: 'counter',
            value: _.filter($scope.user_contacts, function(c) {
              return c.account && c.account.id;
            }).length
          }]]);
        }
      });
    };

    $scope.invite_contact = function(contact) {
      contact.invitation = true;
      UserContactService.add_invitation(contact.id).then(function(data) {
        if (data.success)
          $scope.user_contacts = data.user_contacts;
      });
    };

    $scope.cancel_invitation = function(invitation_id) {
      UserContactService.delete_invitation(invitation_id).then(function(data) {
        if (data.success)
          $scope.user_contacts = data.user_contacts;
      });
    };

    $scope.invitation_status = function(invitation) {
      if (invitation)
        return invitation.status === 0 ? 'Pending' : 'Accepted';
      else
        return '';
    };

    $scope.campaign_status = function(status) {
      return _.findWhere($scope.campaign_statuses, {
        id: status
      }).title;
    };

    $scope.get_pending_invitation_items = function() {
      return _.filter(window.user_contacts, function(contact) {
        return contact.invitation && contact.invitation.status === 0;
      });
    };

    $scope.has_pending_invitation = function(item) {
      return item.invitation && item.invitation.status === 0;
    };

    $scope.get_pending_account_items = function() {
      return _.filter(window.user_contacts, function(contact) {
        return contact.account && contact.account.status == 'pending';
      });
    };

    $scope.has_pending_account = function(item) {
      return item.account && item.account.status == 'pending';
    };

    $scope.update_account_status = function(contact, status) {
      if (contact.account) {
        UserContactService.update_account_status(contact.account.id, status).then(function(data) {
          if (data.success)
            $scope.user_contacts = data.user_contacts;
        });
      }
    };

    $scope.get_account_items = function() {
      return _.filter(window.user_contacts, function(contact) {
        return contact.account && contact.account.id;
      });
    };

    $scope.has_account = function(item) {
      return item.account && item.account.id;
    };

    $scope.get_no_account_items = function() {
      return _.filter(window.user_contacts, function(contact) {
        return !contact.account || !contact.account.id;
      });
    };

    $scope.message_types = [
      {
        id: 0,
        name: 'Typical'
      },
      {
        id: 1,
        name: 'Personal'
      }
    ];

    $scope.campaign_action_types = [
      {
        id: 0,
        name: 'Auto'
      },
      {
        id: 1,
        name: 'Manual'
      }
    ];

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.init = function() {
      $scope.departments = window.departments;
      $scope.user_contacts = window.user_contacts;
      $scope.dialog_contact = angular.copy(window.contact);
      $scope.selected_manage_tab = 0;
      $scope.account_statuses = window.account_statuses;
      $scope.newsletter_categories = window.newsletter_categories;
      $scope.newsletter_frequencies = window.newsletter_frequencies;
      $scope.newsletter_filters = window.newsletter_filters;
      $scope.matching_options = window.matching_options;
      $scope.matching_percentages = window.matching_percentages;
      $scope.frontend_views = window.frontend_views;
      $scope.notification_options = window.notification_options;
      $scope.notification_frequencies = window.notification_frequencies;
      $scope.product_categories = window.product_categories;
      $scope.campaign_statuses = window.campaign_statuses;
      $scope._ = _;
    };

    $scope.init();

  }
}

UserContacts.$inject = ['$scope', '$rootScope', 'UserContactService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-contacts.ctrl.js